import { Nav, Stack, Button } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import logo from "../../assets/logo_fcfm.png";

const allButtons = [
  { label: "Inicio", icon: "bi bi-house", path: "/", requireJefatura: false },
  {
    label: "Atención",
    icon: "bi bi-person-lines-fill",
    path: "/atencion",
    requireJefatura: false,
  },
  {
    label: "Fichas",
    icon: "bi bi-folder2-open",
    path: "/fichas",
    requireJefatura: false,
  },
  {
    label: "Historial",
    icon: "bi bi-clock-history",
    path: "/historial",
    requireJefatura: false,
  },
  {
    label: "Módulos",
    icon: "bi bi-person-workspace",
    path: "/modulos",
    requireJefatura: true,
  },
  {
    label: "Estadísticas",
    icon: "bi bi-bar-chart-line",
    path: "/dashboard",
    requireJefatura: true,
  },
];

const styles = {
  sidebar: {
    maxHeight: "100vh",
  },
  highlight: {
    position: "absolute",
    left: "0.5rem",
    right: "0.5rem",
    height: "2.5rem",
    borderRadius: "0.375rem",
    backgroundColor: "var(--color-accent)",
    zIndex: 1,
  },
};

const SidebarContent = ({ onNavigate, mobile = false }) => {
  const location = useLocation();
  const navRef = useRef(null);
  const [highlightStyle, setHighlightStyle] = useState({ opacity: 0 });
  const [isJefatura, setIsJefatura] = useState(null);
  const [funcionario, setFuncionario] = useState(
    JSON.parse(localStorage.getItem("funcionario"))
  );

  useEffect(() => {
    const stored = JSON.parse(localStorage.getItem("funcionario"));
    setIsJefatura(stored?.cargo === "jefatura");
  }, []);

  const buttons = allButtons.filter(
    (btn) => !btn.requireJefatura || isJefatura
  );

  useEffect(() => {
    if (!navRef.current) return;
    const links = navRef.current.querySelectorAll(".nav-link-custom");

    const activeLink = Array.from(links).find(
      (link) =>
        location.pathname === link.getAttribute("href") ||
        location.pathname.startsWith(link.getAttribute("href") + "/")
    );

    if (activeLink) {
      const rect = activeLink.getBoundingClientRect();
      const parentRect = navRef.current.getBoundingClientRect();
      setHighlightStyle({
        ...styles.highlight,
        top: rect.top - parentRect.top + "px",
        opacity: 1,
        height: rect.height + "px",
      });
    }
  }, [location, isJefatura]);

  const handleClick = () => {
    if (onNavigate) onNavigate();
  };

  return (
    <div
      className="d-flex flex-column h-100 position-relative"
      style={styles.sidebar}
    >
      <div className={mobile ? "p-3 border-bottom" : "p-3"}>
        <Stack direction="horizontal" gap={2}>
          {mobile && (
            <Button
              variant="light"
              size="sm"
              onClick={onNavigate}
              className="ms-auto fs-3"
              style={{ background: "none", border: "none" }}
            >
              <i className="bi bi-x-lg"></i>
            </Button>
          )}
        </Stack>
      </div>

      <div className="position-relative flex-grow-1">
        <Nav ref={navRef} className="flex-column p-3 position-relative">
          {highlightStyle.opacity > 0 && <div style={highlightStyle} />}

          {buttons.map((btn) => {
            const isActive =
              location.pathname === btn.path ||
              location.pathname.startsWith(`${btn.path}/`);

            return (
              <Nav.Link
                key={btn.path}
                as={Link}
                to={btn.path}
                onClick={handleClick}
                className={`d-flex align-items-center mb-3 ps-4 py-3 nav-link-custom ${
                  isActive ? "active" : ""
                }`}
              >
                <i className={`${btn.icon} me-2`}></i>
                {btn.label}
              </Nav.Link>
            );
          })}
        </Nav>
      </div>

      <div className="mt-auto p-3 border-top d-flex">
        <img
          src={logo}
          alt="logo"
          className="img-fluid my-auto"
          style={{ maxHeight: "30px", width: "auto" }}
        />
        <Button
          variant="outline-danger"
          className="ms-auto"
          size="sm"
          onClick={() => {
            const backendUrl = window.location.origin.replace(":3000", ":8000");
            window.location.href = `${backendUrl}/sso/logout`;
          }}
        >
          <i className="bi bi-box-arrow-right me-2"></i>
          Cerrar Sesión
        </Button>
      </div>
    </div>
  );
};

export default SidebarContent;